<template>
  <div id="start-order-button">
    <b-dropdown v-if="showDropdown"
      variant="danger"
      class="primary m-2">

      <template slot="button-content">
        <WaveSpinner v-if="busy" inline color="white"/>
        <span v-else>Start Order</span>
      </template>

      <b-dropdown-item @click="onClickStartOrderForMyself">For Myself</b-dropdown-item>
      <b-dropdown-divider></b-dropdown-divider>
      <b-dropdown-item
        v-for="member in membersExcludingSelf"
        :key="member.username"
        @click="onClickStartOrderForMember(member)"
      >For {{memberName(member)}}</b-dropdown-item>
    </b-dropdown>
    <button v-else
      :disabled="flags.legacy"
      :title="flags.legacy ? 'Cannot start order on IE11' : ''"
      @click="onClickStartOrderButton"
      style="display: inline-block"
      class="btn btn-default">
      <WaveSpinner v-if="busy" inline color="white"/>
      <span v-else>Start Order</span>
    </button>
  </div>
</template>

<style lang="scss">
@import "~scss/colors";
#start-order-button {
  .primary {
    background: $red;
    color: $white;
    border: $red 1px solid;
    line-height: 20px;

    .btn-danger {
      height: 48px;
    }
  }
}
</style>

<script>
import {mapGetters, mapActions} from 'vuex';
export default {
  props: ['member'],
  data() {
    return {busy: false}
  },
  computed: {
    ...mapGetters(['designId', 'flags', 'members', 'user', 'isAdmin']),
    membersExcludingSelf(){
      return this.members.filter(member => member.email !== this.user.email);
    },
    showDropdown() {
      // If the member is passed we will only start order for that member
      // Feature is gated, and requires admin access.
      // We disable the button for legacy. Therefore don't show the dropdown
      return !this.member && this.flags.startOrderDropdown && this.isAdmin && !this.flags.legacy;
    }
  },
  mounted() {
    if (this.showDropdown) this.loadTeamMembers();
  },
  methods: {
    ...mapActions(['startOrderFromProductTemplate', 'setOrdereeId', 'loadTeamMembers']),
    async onClickStartOrderButton() {
      // Clicked start order button without dropdown.
      // If member is set, member -> orderee (eg, member detail page)
      // If orderer, user -> orderee (eg, orderee on dashboard or setup page)
      // If admin, no orderee (eg, admin on dashboard before dropdown implemented)
      if (this.member || !this.isAdmin) {
        return this.onClickStartOrderForMember(this.member || this.user);
      }
      // Admin, no orderee
      this.busy = true;
      await this.setOrdereeId(null);
      await this.startOrderFromProductTemplate();
      this.$router.push({name: 'Editor', params: {id: this.designId}});
    },
    async onClickStartOrderForMyself() {
      return this.onClickStartOrderForMember(this.user);
    },
    async onClickStartOrderForMember(member) {
      this.busy = true;
      await this.setOrdereeId(member.id);
      await this.startOrderFromProductTemplate(member.team_user_id);
      this.$router.push({name: 'Editor', params: {id: this.designId}});
    },
    memberName(member) {
      // Return name, fall back to email
      let {first_name, last_name, email} = member;
      let name = (first_name+' '+last_name).trim();
      return name || email;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/StartOrderButton.vue